import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './BottomNav.css';

function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { canCoach } = useAuth();

  const navItems = [
    {
      id: 'home',
      label: 'Home',
      icon: '🏠',
      path: '/athlete',
      active: location.pathname === '/athlete'
    },
    {
      id: 'progress',
      label: 'Progressi',
      icon: '📈',
      path: '/athlete/progress',
      active: location.pathname.startsWith('/athlete/progress')
    },
    {
      id: 'programs',
      label: 'Schede',
      icon: '📚',
      path: '/athlete/programs',
      active: location.pathname.startsWith('/athlete/programs')
    },
    // Voce Coach: solo con Modalità Coach attiva (profilo unico)
    ...(canCoach ? [{
      id: 'coach',
      label: 'Coach',
      icon: '💪',
      path: '/coach',
      active: location.pathname.startsWith('/coach')
    }] : []),
    {
      id: 'community',
      label: 'Community',
      icon: '👥',
      path: '/athlete/community',
      active: location.pathname.startsWith('/athlete/community')
    },
    {
      id: 'profile',
      label: 'Profilo',
      icon: '🏆',
      path: '/athlete/profile',
      active: location.pathname === '/athlete/profile'
    }
  ];

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <nav className={`bottom-nav ${navItems.length > 5 ? 'bottom-nav--compact' : ''}`}>
      {navItems.map(item => (
        <button
          key={item.id}
          className={`bottom-nav-item ${item.active ? 'active' : ''}`}
          onClick={() => handleNavigate(item.path)}
          aria-label={item.label}
        >
          <span className="nav-icon">{item.icon}</span>
          <span className="nav-label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
}

export default BottomNav;
